export default function (ModalService) {
    return function (notes, discrepancies, lockedDiscrepancyId) {
        return ModalService.showModal({
            controller: require('../../controllers/notes/add/addNoteCtrl'),
            template: require('../../controllers/notes/add/addNote.html'),
            controllerAs: 'addNote',
            inputs: {
                notes,
                discrepancies,
                lockedDiscrepancyId
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/notes/openAddNoteModal.js